import { Component, Prop, h } from '@stencil/core';
import { ButtonType } from './interfaces';

@Component({
  tag: 'ugc-button',
  styleUrl: 'ugc-button.scss',
  shadow: false,
})
export class UgcButton {
  @Prop({ reflect: true }) type: string = 'primary';
  @Prop({ reflect: true }) width: string = '';
  @Prop({ reflect: true }) height: string = '';
  @Prop({ reflect: true }) fontSize: string = '14';
  @Prop({ reflect: true }) fontWeight: string = '';
  @Prop({ reflect: true }) disabled: boolean = false;
  @Prop({ reflect: true }) customStyle?: any = {};

  render() {
    const buttonStyle = {
      width: this.width === '' ? '100%' : `${this.width}px`,
      height: this.height === '' ? 'auto' : `${this.height}px`,
      fontSize: `${this.fontSize}px`,
      fontWeight: this.fontWeight === '' ? 'bold' : this.fontWeight,
      ...this.customStyle,
    };

    return (
      <button
        class={{
          'ugc-button': true,
          [`ugc-button-${ButtonType[this.type]}`]: true,
          [`${ButtonType[this.type]}-disabled`]: this.disabled,
        }}
        disabled={this.disabled}
        style={buttonStyle}
      >
        <slot />
      </button>
    );
  }
}
